var path = '/templates/zenclerk_s/directives/conversion_tag_checker/conversion_tag_integration_brief.html';
var html = "<p class=\"config-lead margin-y\" translate=directives.conversionTagChecker.integrationBrief translate-value-service=\"{{ vm.ZcsOemService.getName() }}\"></p>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_s_modules/zenclerk_s/directives/conversion_tag_checker/conversion_tag_integration_brief.html
// module id = 1328
// module chunks = 0